const entityType = {
  quote: 'Quote',
  changeOrder: 'ChangeOrder',
}
export default entityType
